import { createClient } from "@supabase/supabase-js";

const supabaseDB = createClient(
  process.env.REACT_APP_SUPABASE_URL,
  process.env.REACT_APP_SUPABASE_PUBLIC_KEY
);

export { supabaseDB };
